import React from 'react'

import { AppUrls } from 'common/AppUrls'
import { PageHeaderWithButtons } from 'components/shared'
import { ChangePasswordForm } from './components/Form'
import { useTranslation } from 'react-i18next'

export const ChangePassword = () => {
    const { t } = useTranslation()

    return (
        <>
            <PageHeaderWithButtons backUrl={AppUrls.account} pageName={t('change_password')} />
            <ChangePasswordForm />
        </>
    )
}
